import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

export const ToastContainer = styled.div<{ visible: boolean; clickable: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 300px;
  max-width: 400px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 16px;
  margin-bottom: 12px;
  animation: ${(props) => (props.visible ? slideIn : slideOut)} 0.3s ease-out;
  cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};
  transition: transform 0.2s, box-shadow 0.2s;
  border-left: 4px solid #4CAF50;

  &:hover {
    ${(props) =>
      props.clickable &&
      `
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    `}
  }

  @media (max-width: 480px) {
    min-width: calc(100vw - 32px);
    max-width: calc(100vw - 32px);
  }
`;

export const ToastContent = styled.div`
  flex: 1;
  margin-right: 12px;
`;

export const ToastTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
`;

export const ToastBody = styled.div`
  font-size: 13px;
  color: #666;
  line-height: 1.4;
  word-wrap: break-word;
`;

export const ToastClose = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.2s, color 0.2s;
  flex-shrink: 0;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
    color: #333;
  }
`;

export const ToastWrapper = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  pointer-events: none;

  @media (max-width: 480px) {
    top: 10px;
    right: 10px;
    left: 10px;
    align-items: stretch;
  }

  > * {
    pointer-events: auto;
  }
`;
